import { FileText, MapPin, Package, Truck, Building2, Zap, Video, Home, Phone, ChevronDown } from 'lucide-react';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Sitemap() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollDown = () => {
    window.scrollBy({ top: window.innerHeight, behavior: 'smooth' });
  };

  const sitemapSections = [
    {
      title: 'Hauptseiten',
      icon: Home,
      links: [
        { name: 'Startseite', path: '/' },
        { name: 'Leistungen', path: '/leistungen' },
        { name: 'Preise', path: '/preise' },
        { name: 'Ablauf', path: '/ablauf' },
        { name: 'FAQ', path: '/faq' },
        { name: 'Kontakt', path: '/kontakt' },
      ],
    },
    {
      title: 'Umzugsservices',
      icon: Truck,
      links: [
        { name: 'Komplettumzug', path: '/komplettumzug' },
        { name: 'Teilumzug', path: '/teilumzug' },
        { name: 'Express-Umzüge', path: '/express-umzuege' },
        { name: 'Firmenumzüge', path: '/firmenumzuege' },
      ],
    },
    {
      title: 'Zusatzleistungen',
      icon: Package,
      links: [
        { name: 'Zollabwicklung', path: '/zollabwicklung' },
        { name: 'Verpackungsmaterial', path: '/verpackungsmaterial' },
        { name: 'Zwischenlagerung', path: '/zwischenlagerung' },
        { name: 'Endreinigung', path: '/endreinigung' },
      ],
    },
    {
      title: 'Regionale Umzüge',
      icon: MapPin,
      links: [
        { name: 'Umzug Zürich - Deutschland', path: '/umzug-zuerich-deutschland' },
        { name: 'Umzug Basel - Deutschland', path: '/umzug-basel-deutschland' },
        { name: 'Umzug Bern - Deutschland', path: '/umzug-bern-deutschland' },
        { name: 'Umzug Luzern - Deutschland', path: '/umzug-luzern-deutschland' },
        { name: 'Umzug Aargau - Deutschland', path: '/umzug-aargau-deutschland' },
        { name: 'Umzug Winterthur - Deutschland', path: '/umzug-winterthur-deutschland' },
        { name: 'Umzug St. Gallen - Deutschland', path: '/umzug-stgallen-deutschland' },
        { name: 'Umzug Zug - Deutschland', path: '/umzug-zug-deutschland' },
      ],
    },
    {
      title: 'Spezielle Angebote',
      icon: Zap,
      links: [
        { name: 'Sofort Besichtigung', path: '/sofort-besichtigung' },
        { name: 'Offerte anfordern', path: '/offerte-anfordern' },
      ],
    },
    {
      title: 'Rechtliches',
      icon: FileText,
      links: [
        { name: 'Datenschutz', path: '/datenschutz' },
        { name: 'AGB', path: '/agb' },
        { name: 'Impressum', path: '/impressum' },
      ],
    },
  ];

  return (
    <div className="min-h-screen">
      <div className="relative min-h-[60vh] bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
        <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHZpZXdCb3g9IjAgMCA2MCA2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0zNiAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnptMCAxOGMzLjMxNCAwIDYgMi42ODYgNiA2cy0yLjY4NiA2LTYgNi02LTIuNjg2LTYtNiAyLjY4Ni02IDYtNnoiIHN0cm9rZT0iIzRhNWI2ZSIgc3Ryb2tlLXdpZHRoPSIuNSIgb3BhY2l0eT0iLjEiLz48L2c+PC9zdmc+')] opacity-30"></div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
            <div className="inline-block mb-6 px-4 py-2 bg-white/10 backdrop-blur-sm rounded-full border border-white/20">
              <span className="text-sm font-semibold text-white">Sitemap</span>
            </div>

            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              Alle Seiten im Überblick
            </h1>

            <p className="text-xl md:text-2xl text-slate-300 max-w-3xl mb-12 leading-relaxed">
              Finden Sie schnell und einfach alle Informationen zu unseren Umzugsservices von der Schweiz nach Deutschland
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="tel:0800700100"
                className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-green-600 to-green-500 text-white px-8 py-4 rounded-xl font-semibold hover:from-green-700 hover:to-green-600 transition shadow-xl hover:shadow-2xl hover:scale-105 transform"
              >
                <Phone className="w-5 h-5" />
                <span>0800 700 100</span>
              </a>
              <Link
                to="/offerte-anfordern"
                className="inline-flex items-center justify-center space-x-2 bg-white text-slate-900 px-8 py-4 rounded-xl font-semibold hover:bg-slate-100 transition shadow-xl hover:shadow-2xl hover:scale-105 transform"
              >
                <span>Offerte anfordern</span>
              </Link>
            </div>

            <button
              onClick={scrollDown}
              className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 hover:text-white transition animate-bounce"
              aria-label="Nach unten scrollen"
            >
              <ChevronDown className="w-8 h-8" />
            </button>
          </div>
        </div>
      </div>

      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {sitemapSections.map((section, index) => {
              const Icon = section.icon;
              return (
                <div
                  key={index}
                  className="bg-white rounded-2xl border-2 border-slate-100 p-8 hover:border-slate-200 hover:shadow-lg transition"
                >
                  <div className="flex items-center space-x-3 mb-6">
                    <div className="p-3 bg-gradient-to-br from-slate-900 to-slate-700 rounded-xl">
                      <Icon className="w-6 h-6 text-white" />
                    </div>
                    <h2 className="text-2xl font-bold text-slate-900">
                      {section.title}
                    </h2>
                  </div>
                  <ul className="space-y-3">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        <Link
                          to={link.path}
                          className="text-slate-600 hover:text-slate-900 hover:translate-x-1 transition inline-flex items-center space-x-2 group"
                        >
                          <span className="text-slate-400 group-hover:text-slate-600">→</span>
                          <span>{link.name}</span>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="py-20 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Nicht gefunden was Sie suchen?
          </h2>
          <p className="text-xl text-slate-300 mb-10 max-w-2xl mx-auto">
            Kontaktieren Sie uns direkt für eine persönliche Beratung zu Ihrem Umzug von der Schweiz nach Deutschland
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="tel:0800700100"
              className="inline-flex items-center justify-center space-x-2 bg-gradient-to-r from-green-600 to-green-500 text-white px-8 py-4 rounded-xl font-semibold hover:from-green-700 hover:to-green-600 transition shadow-xl hover:shadow-2xl hover:scale-105 transform"
            >
              <Phone className="w-5 h-5" />
              <span>0800 700 100</span>
            </a>
            <Link
              to="/kontakt"
              className="inline-flex items-center justify-center space-x-2 bg-white text-slate-900 px-8 py-4 rounded-xl font-semibold hover:bg-slate-100 transition shadow-xl hover:shadow-2xl hover:scale-105 transform"
            >
              <span>Kontaktformular</span>
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
